import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Card } from './ui/card';

// Iter288 (perf) — the CDN JPEG was 575 KB with no cache headers; now
// served as locally-hosted, pre-optimised WebP variants with a srcset.
const HERO_IMG = '/img/climbing-kokkina-800.webp';
const HERO_SRCSET =
  '/img/climbing-kokkina-480.webp 480w, /img/climbing-kokkina-800.webp 800w, /img/climbing-kokkina-1200.webp 1200w';

const ClimbingSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white" data-testid="home-climbing">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            {/* whitespace-nowrap keeps "Πεδία Αναρρίχησης Υμηττού" on a
                single line at md+; on mobile it wraps naturally. */}
            <h2 className="text-4xl font-bold text-gray-900 mb-6 md:whitespace-nowrap">{t('climbing.title')}</h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">{t('climbing.description')}</p>
            <Button asChild size="lg" className="bg-gray-900 hover:bg-gray-800 group">
              <Link to="/hymettus/climbing" data-testid="home-discover-routes-cta">
                {t('climbing.discoverRoutes')}
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>
          </div>
          <div className="order-1 md:order-2">
            <Card className="overflow-hidden border border-gray-100 shadow-lg bg-white">
              <img
                src={HERO_IMG}
                srcSet={HERO_SRCSET}
                sizes="(min-width: 768px) 50vw, 100vw"
                alt={t('climbing.title')}
                width={1000}
                height={750}
                loading="lazy"
                decoding="async"
                className="w-full h-[500px] object-cover"
              />
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClimbingSection;